import { mergeUint8Arrays } from "./buffers";

const MIN_CHUNK_SIZE = 4096 * 12;
const WAV_HEADER_SIZE = 44;

export const getStreamWithHeadersRemoved = (
  stream: ReadableStream<Uint8Array>,
  metadataPresent = true
) => {
  let cleanupDone = false;
  const metaAndHeaderTransformer = new TransformStream<Uint8Array, Uint8Array>({
    transform(chunk, controller) {
      let transformedChunk = chunk;
      if (!cleanupDone) {
        const lengthToRemove = metadataPresent
          ? 16 + WAV_HEADER_SIZE
          : 8 + WAV_HEADER_SIZE;
        transformedChunk = chunk.slice(lengthToRemove);
        cleanupDone = true;
      }
      controller.enqueue(transformedChunk);
    },
  });

  return stream.pipeThrough(metaAndHeaderTransformer);
};

export const getStreamWithEqualSizeChunks = (
  stream: ReadableStream<Uint8Array>,
  desiredChunkSize = MIN_CHUNK_SIZE
) => {
  let buffer = new Uint8Array(0);
  const chunkTransformer = new TransformStream<Uint8Array, Uint8Array>({
    async transform(chunk, controller) {
      buffer = mergeUint8Arrays([buffer, chunk]);

      while (buffer.length >= desiredChunkSize) {
        const outputChunk = buffer.slice(0, desiredChunkSize);
        buffer = buffer.slice(desiredChunkSize);
        controller.enqueue(outputChunk);
      }
    },
    flush(controller) {
      if (buffer && buffer.length > 0) {
        controller.enqueue(buffer);
      }
    },
  });

  return stream.pipeThrough(chunkTransformer);
};
